import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { handleCallback } from '../auth/oidc';

export default function CallbackPage() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('Anmeldung läuft...');

  useEffect(() => {
    (async () => {
      try {
        const url = window.location.href;
        const hasCode = new URL(url).searchParams.get('code');
        if (!hasCode) {
          setMessage(
            'Kein Autorisierungscode gefunden. Bitte starte den Login erneut.',
          );
          return;
        }
        const returnTo = await handleCallback(url);
        navigate(returnTo, { replace: true });
      } catch (err) {
        const detail = err instanceof Error ? err.message : String(err);
        setMessage(`Login fehlgeschlagen: ${detail}`);
      }
    })();
  }, [navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen gap-3 text-center">
      <h2 className="text-large font-bold">Callback</h2>
      <p>{message}</p>
    </div>
  );
}
